import type { MeetingFilters } from "@/infrastructure/repositories/meetings.supabase.repository";
import type { EntityType } from "@/infrastructure/supabase/database.types";

export const meetingsKeys = {
  all: ["meetings"] as const,
  list: (filters: MeetingFilters = {}) => [...meetingsKeys.all, "list", filters] as const,
  detail: (id: string) => [...meetingsKeys.all, "detail", id] as const,
  bySlug: (slug: string) => [...meetingsKeys.all, "bySlug", slug] as const,
  forEntity: (entityType: EntityType, entityId: string) =>
    [...meetingsKeys.all, "forEntity", entityType, entityId] as const,
};
